import HostedOnboardingButton from './HostedOnboardingButton';
import OnboardingLinkButton from './OnboardingLinkButton';

export default {
  HostedOnboardingButton,
  OnboardingLinkButton,
};
